import React, { useRef } from 'react';
import LandingPage from './components/LandingPage';
import Navbar from './layout/navbar';
import Services from './components/Service';
import About from './components/About';
import ContactUs from './components/Contact';
import  PhotoGallery  from './components/Photo';
import VideoGallery from './components/Videos';

function App() {
  const aboutRef = useRef(null);

  // Scroll to About section after Services completes
  const handleServicesFinish = () => {
    if (aboutRef.current) {
      aboutRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />

   
      <main className="flex-1">
       
        <LandingPage />

       
        <Services onFinish={handleServicesFinish} />

        <PhotoGallery />

     
      <div ref={aboutRef}>
          <About />
        </div> 

        <VideoGallery />

        <ContactUs /> 
      </main>

 

    </div>
  );
}

export default App;
